"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getApiUrl;

var _Url = _interopRequireDefault(require("urlinator/Url"));

var _getApiHostForEnviroment = _interopRequireDefault(require("./getApiHostForEnviroment"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _underscore = _interopRequireDefault(require("../vendor/underscore.custom"));

function getApiUrl(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!path || typeof path !== 'string' || !_underscore.default.isObject(params) || Array.isArray(params)) {
    return null;
  }

  var pathWithLeadingSlash = path[0] === '/' ? path : "/" + path;
  var url = new _Url.default(pathWithLeadingSlash, {
    hostname: (0, _getApiHostForEnviroment.default)(),
    params: Object.assign({
      portalId: _PortalIdParser.default.get()
    }, params)
  });
  return url ? url.href : null;
}

module.exports = exports.default;